<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        document.documentElement.classList.add('js-enabled');
        window.foucTimeout = setTimeout(function() {
            document.documentElement.classList.remove('js-enabled');
        }, 2000);
    </script>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="theme-color" content="#F8F9FA">
    <link rel="preload" as="font" href="fonts/Lato-Regular.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Lato-Bold.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Fredoka-SemiBold.woff2" type="font/woff2" crossorigin>
    <title>Fees, Funding & Policies | Little Explorers Nursery</title>
    <link rel="icon" type="image/svg+xml" href="images/logo.svg">
    <meta name="description" content="Transparent tuition rates, government funding guidelines, and admissions policies for our Anytown nursery.">
    <!-- 2026 AI Agent Discovery Links -->
    <link rel="alternate" type="text/plain" title="LLM Summary (Low Token)" href="/llms.txt">
    <link rel="alternate" type="text/plain" title="LLM Full Knowledge Base (High Token)" href="/llms-full.txt">
    <!-- Open Graph / Social Media -->
    <meta property="og:type" content="website">
    <meta property="og:url" content="https://littleexplorersnursery.example.com/fees">
    <meta property="og:title" content="Nursery Fees & Government Funded Childcare | Anytown AT1">
    <meta property="og:description" content="Transparent, all-inclusive nursery fees with no hidden costs. We proudly accept 15 and 30 hours government funded childcare and Tax-Free Childcare schemes.">
    <meta property="og:image" content="https://littleexplorersnursery.example.com/images/og-image.jpg">
    <meta name="twitter:card" content="summary_large_image">
    
    <link rel="stylesheet" href="css/style.css">
    <link rel="stylesheet" href="css/components/fees.css">
    <script type="module" src="js/lib/dotlottie/dotlottie-player.mjs"></script>
    
    <!-- 2026 Speculation Rules for Instant Navigation -->
    <script type="speculationrules">
    {
      "prerender": [{
        "source": "document",
        "where": {"href_matches": "/*"},
        "eagerness": "moderate"
      }]
    }
    </script>
    <script defer src="/vendor/gsap.min.js"></script>
    <script defer src="/vendor/ScrollTrigger.min.js"></script>
    <script type="module" src="/js/main.js"></script>
    <script type="module" src="/js/global-animations.js"></script>
    <script type="module" src="/js/fees.js"></script>
</head>
<body>

    <!-- MOBILE NAVBAR START -->
    <nav class="mobile-navbar" aria-label="Mobile top bar">
        <a href="/" class="mobile-logo-link">
            <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="mobile-logo" width="45" height="44" loading="eager" fetchpriority="high">
        </a>
        <button type="button" class="mobile-menu-toggle" aria-label="Toggle navigation" aria-expanded="false">
            <span class="bar"></span>
            <span class="bar"></span>
        </button>
    </nav>

    <!-- MOBILE CURTAIN OVERLAY NAVIGATION -->
    <div class="mobile-menu-overlay" aria-hidden="true" style="display: none;">
        <nav class="mobile-overlay-nav">
            <ul class="mobile-overlay-list">
                <li><a href="/" class="mobile-overlay-link">Home</a></li>
                <li><a href="rooms" class="mobile-overlay-link">Our Rooms</a></li>
                <li><a href="staff" class="mobile-overlay-link">Our Team</a></li>
                <li><a href="fees" class="mobile-overlay-link active">Fees & Info</a></li>
                <li><a href="contact" class="mobile-overlay-link cta-pill">Book a Tour</a></li>
            </ul>
        </nav>
    </div>
    <!-- MOBILE NAVBAR END -->

    <!-- DESKTOP NAVBAR START -->
    <header class="site-header">
        <div class="container header-inner">
            <a href="/" class="logo-link">
                <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="site-logo" width="61" height="60" loading="eager" fetchpriority="high">
            </a>
            <nav class="nav-links">
                <a href="/">Home</a>
                <a href="rooms">Our Rooms</a>
                <a href="staff">Our Team</a>
                <a href="fees" class="active">Fees & Info</a>
            </nav>
            <div class="header-cta">
                <a href="contact" class="btn btn-primary">Book a Tour</a>
            </div>
        </div>
    </header>
    <!-- DESKTOP NAVBAR END -->

    <main>
        
        <!-- PAGE TITLE -->
        <section class="fees-header text-center section-padding" style="padding-bottom: 2rem;">
            <div class="container">
                <div class="section-header" style="margin-bottom: 0;">
                    <h1>Fees & 
                        <span class="crayon-wrap">
                            Funding
                                <!-- Hand-drawn SVG circle path from index -->
                                <svg class="crayon-svg circle" viewBox="0 0 100 40" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 10,20 C 10,5 90,5 90,20 C 90,35 15,38 15,20" fill="none" stroke="var(--color-accent)" stroke-width="3" stroke-linecap="round"></path>
                            </svg>
                        </span>
                    </h1>
                    <p>Transparent pricing, simplified funding schemes, and straightforward admissions policies.</p>
                </div>
            </div>
        </section>

        <!-- THE ARTISANAL LEDGER (Replaces the SaaS Table) -->
        <section class="fees-ledger-section section-padding" style="padding-top: 1rem;">
            <div class="container">
                <div class="ledger-wrapper">
                    
                    <div class="table-container">
                        <table class="fees-table">
                            <thead>
                                <tr>
                                    <th>Session Type</th>
                                    <th>Hours</th>
                                    <th>Inclusions & Care</th>
                                    <th>Daily Rate</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="session-name">Full Week (Mon - Fri)</td>
                                    <td class="session-hours">8:00am - 6:00pm</td>
                                    <td class="session-details">All-inclusive care, discounted flat rate</td>
                                    <td class="session-price">£360.00 <span class="price-period">/ wk</span></td>
                                </tr>
                                <tr>
                                    <td class="session-name">Full Day Session</td>
                                    <td class="session-hours">8:00am - 6:00pm</td>
                                    <td class="session-details">All-inclusive care, single day booking</td>
                                    <td class="session-price">£78.00 <span class="price-period">/ day</span></td>
                                </tr>
                                <tr>
                                    <td class="session-name">Morning Session</td>
                                    <td class="session-hours">8:00am - 1:00pm</td>
                                    <td class="session-details">Includes freshly prepared breakfast & hot lunch</td>
                                    <td class="session-price">£48.00 <span class="price-period">/ sess</span></td>
                                </tr>
                                <tr>
                                    <td class="session-name">Afternoon Session</td>
                                    <td class="session-hours">1:00pm - 6:00pm</td>
                                    <td class="session-details">Includes fresh afternoon high tea & light dinner</td>
                                    <td class="session-price">£46.00 <span class="price-period">/ sess</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- All Inclusive Trust Banner -->
                    <div class="all-inclusive-banner">
                        <div class="banner-icon-col">
                            <span class="mask-icon" style="-webkit-mask-image: url('images/icons/househeart.svg'); mask-image: url('images/icons/househeart.svg'); width: 32px; height: 32px; background-color: var(--color-primary); flex-shrink: 0;"></span>
                        </div>
                        <div class="banner-text-col">
                            <h3>Absolutely no hidden extras.</h3>
                            <p>To keep things as simple and stress-free as possible, our session rates are <strong class="tldr-stat">completely all-inclusive</strong>. All freshly cooked meals, snacks, premium nappies, wipes, formula, and our specialised visiting yoga and forest school sessions are provided with <strong>zero top-up charges</strong>.</p>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <!-- FUNDING & GOVERNMENT ASSISTANCE (Cloud & Piggybank) -->
        <section class="funding-section section-padding">
            <div class="container">
                <div class="funding-grid">
                    
                    <!-- Cloud Card: 15 & 30 Hours -->
                    <div class="funding-card cloud-container">
                        <svg class="shape-protrusion cloud-top" viewBox="0 0 300 80" preserveAspectRatio="xMidYMax meet" aria-hidden="true" focusable="false">
                            <use href="images/svgs/sprites.svg#cloud-box"></use>
                        </svg>
                        
                        <h2>15 & 30 Funded Hours</h2>
                        <p class="lead-text">We actively accept the UK government funding schemes for 2, 3, and 4-year-olds.</p>
                        <div class="funding-details-text">
                            <p>All eligible families can access either <strong class="tldr-stat">15 or 30 hours</strong> of funded childcare per week. We operate these hours across <strong class="tldr-stat">51 weeks of the year</strong> (stretched funding), allowing us to spread your savings evenly to keep your monthly invoices highly predictable.</p>
                            <p>Our management team will happily calculate your exact monthly invoice and handle all the government paperwork for you upon registration.</p>
                        </div>
                    </div>

                    <!-- Cloud Card: Tax-Free Childcare -->
                    <div class="funding-card cloud-container">
                        <svg class="shape-protrusion cloud-top-alt" viewBox="0 0 300 80" preserveAspectRatio="xMidYMax meet" aria-hidden="true" focusable="false">
                            <use href="images/svgs/sprites.svg#cloud-box"></use>
                        </svg>
                        
                        <h2>Tax-Free Childcare</h2>
                        <p class="lead-text">Save up to £2,000 per child, every single year, through the government top-up scheme.</p>
                        <div class="funding-details-text">
                            <p>For every £8.00 you pay into your online Tax-Free Childcare account, the UK government automatically tops it up with an extra £2.00. This is effectively a <strong class="tldr-stat">20% discount</strong> on your nursery fees.</p>
                            <p>We are fully registered with the government's Tax-Free Childcare gateway, as well as all major workplace childcare voucher and salary sacrifice schemes. Setting this up is incredibly quick and simple.</p>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <!-- POLICIES & GUIDELINES (The Noticeboard) -->
        <section class="policies-section section-padding" style="position: relative; overflow: hidden;">
            <div class="container" style="position: relative; z-index: 2;">
                
                <!-- BACKGROUND NURSERY MAGIC -->
                <div class="nursery-magic-bg" aria-hidden="true" data-nosnippet>
                    <!-- 2. Swirl (Left Gutter) -->
                    <svg class="policy-doodle pd-2" viewBox="0 0 100 100" fill="none" stroke="var(--color-accent)" stroke-width="5" stroke-linecap="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-2"></use></svg>

                    <!-- 4. Triangle (Right Gutter) -->
                    <svg class="policy-doodle pd-4" viewBox="0 0 100 100" fill="none" stroke="var(--color-text-muted)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-4"></use></svg>

                    <!-- 6. Heart (Outside Left) -->
                    <svg class="policy-doodle pd-6" viewBox="0 0 100 100" fill="none" stroke="var(--color-primary)" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-6"></use></svg>

                    <!-- 8. Asterisk (Outside Right) -->
                    <svg class="policy-doodle pd-8" viewBox="0 0 100 100" fill="none" stroke="var(--color-text-muted)" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-8"></use></svg>

                    <!-- 10. Cloud (Outside Right) -->
                    <svg class="policy-doodle pd-10" viewBox="0 0 100 100" fill="none" stroke="var(--color-accent)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-10"></use></svg>

                    <!-- 12. Sun Rays (Outside Left) -->
                    <svg class="policy-doodle pd-12" viewBox="0 0 100 100" fill="none" stroke="var(--color-primary)" stroke-width="5" stroke-linecap="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-12"></use></svg>
                    
                    <!-- 14. Paper Aeroplane (Left Gutter) -->
                    <svg class="policy-doodle pd-14 doodle-plane" viewBox="0 0 100 100" fill="none" stroke="var(--color-accent)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-14"></use></svg>

                    <!-- 16. Balloon (Right Gutter) -->
                    <svg class="policy-doodle pd-16 doodle-balloon" viewBox="0 0 100 100" fill="none" stroke="var(--color-primary)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-16"></use></svg>

                </div>
                
                <div class="section-header text-center" style="margin-bottom: 4rem;">
                    <h2>Key 
                        <span class="crayon-wrap">
                            Guidelines
                            <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 5,10 C 30,15 70,5 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                            </svg>
                        </span>
                    </h2>
                </div>

                <div class="policies-grid">
                    <div class="policy-card">
                        <div class="policy-header">
                            <h3>
                                <span class="crayon-wrap">Securing a Place
                                    <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                        <path d="M 5,10 C 30,15 70,5 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                                    </svg>
                                </span>
                            </h3>
                        </div>
                        <p>To register your child, we require a <strong class="tldr-stat">£200&nbsp;non-refundable registration fee</strong>, alongside a <strong class="tldr-stat">£400 refundable deposit</strong> to secure their start date.</p>
                        <p>The £400 deposit is fully protected and is returned directly to your bank account once your child completes their journey with us and leaves for primary school.</p>
                        
                        <a href="#" class="policy-link-btn" style="margin-top: auto;">Read Full Policy</a>
                    </div>

                    <div class="policy-card">
                        <div class="policy-header">
                            <h3>
                                <span class="crayon-wrap">Home Visits & Settling In
                                    <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 5,10 C 30,15 70,5 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                            </svg>
                                </span>
                            </h3>
                        </div>
                        <p>Before your child's first day, we arrange a <strong>personal home visit</strong>. This allows us to see your child in their own environment, gain background info, and talk through any concerns.</p>
                        <p>Following this, we invite you both to the Nursery for tailored settling-in sessions to ensure the transition is smooth and secure.</p>
                        
                        <a href="#" class="policy-link-btn" style="margin-top: auto;">Read Full Policy</a>
                    </div>

                    <div class="policy-card">
                        <div class="policy-header">
                            <h3>
                                <span class="crayon-wrap">Illness & Exclusion
                                    <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 5,10 C 30,15 70,5 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                            </svg>
                                </span>
                            </h3>
                        </div>
                        <p>To protect all children and staff, we enforce a strict exclusion policy. Children must be kept at home for <strong>48 hours</strong> following the last episode of vomiting or diarrhoea, and <strong>24 hours</strong> following a raised temperature.</p>
                        <p>If an urgent medical opinion is required at nursery, our management team and qualified first aiders will immediately call an ambulance and act in loco parentis.</p>
                        
                        <a href="#" class="policy-link-btn" style="margin-top: auto;">Read Full Policy</a>
                    </div>

                    <div class="policy-card">
                        <div class="policy-header">
                            <h3>
                                <span class="crayon-wrap">Safeguarding
                                    <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 5,10 C 30,15 70,5 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                            </svg>
                                </span>
                            </h3>
                        </div>
                        <p>We are fully committed to providing a trusting, caring atmosphere where children feel completely safe and secure. Our <strong>Designated Safeguarding Lead (DSL)</strong> oversees all child protection protocols.</p>
                        <p>All staff receive rigorous statutory training to recognise signs of concern, ensuring children are never placed at risk while in our care.</p>
                        
                        <a href="safeguarding" class="policy-link-btn" style="margin-top: auto;">Read Full Policy</a>
                    </div>

                    <div class="policy-card">
                        <div class="policy-header">
                            <h3>
                                <span class="crayon-wrap">Arrivals & Departures
                                    <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 5,10 C 30,15 70,5 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                            </svg>
                                </span>
                            </h3>
                        </div>
                        <p>Parents must pass the care of their child directly to a specific member of staff inside their classroom.</p>
                        <p>No child will ever be handed over to anyone other than the known parent or carer unless a prior agreement has been made with the nursery management.</p>
                        
                        <a href="#" class="policy-link-btn" style="margin-top: auto;">Read Full Policy</a>
                    </div>

                    <div class="policy-card">
                        <div class="policy-header">
                            <h3>
                                <span class="crayon-wrap">Nutrition & Hygiene
                                    <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 5,10 C 30,15 70,5 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                            </svg>
                                </span>
                            </h3>
                        </div>
                        <p>Our kitchen holds the highest <strong>5-star Environmental Health hygiene award</strong>. We prepare all meals fresh daily using organic ingredients wherever possible.</p>
                        <p>All food is baked, grilled, or shallow-fried using a minimum of cooking oil. We never deep fat fry any food, and fresh fruit is always available!</p>
                        
                        <a href="#" class="policy-link-btn" style="margin-top: auto;">Read Full Policy</a>
                    </div>

                </div>
            </div>
        </section>

        <!-- DUAL PATHWAY PRE-FOOTER (Hidden until client confirms web registrations) 
        <section class="pre-footer-dual section-padding text-center">
            <div class="container">
                <div class="dual-cta-grid">
                    <div class="cta-box">
                        <h3>Want to see our spaces first?</h3>
                        <p>Book a personal, guided walkthrough with Jane or Mary to explore our rooms and meet the team.</p>
                        <a href="contact" class="btn btn-primary">Book a Tour</a>
                    </div>
                    <div class="cta-box highlight-box">
                        <h3>Ready to join the family?</h3>
                        <p>Fill out our digital enrollment application to secure your child's start date and deposit.</p>
                        <a href="contact?action=register" class="btn btn-primary">Apply to Register</a>
                    </div>
                </div>
            </div>
        </section>
        -->

        <!-- STANDARD PRE-FOOTER CTA START -->
        <section class="pre-footer section-padding text-center">
            <div class="container">
                <h2>Experience our world for yourself</h2>
                <p>We would love to show you around our beautiful spaces and answer any questions you have about your child's early years journey.</p>
                <a href="contact" class="btn btn-primary btn-large">Book a Personal Tour</a>
            </div>
        </section>
        <!-- PRE-FOOTER CTA END -->

        <!-- FREQUENTLY ASKED QUESTIONS -->
        <section class="faq-section section-padding">
            <div class="container">
                
                <!-- Moved Abacus Lottie -->
                <div class="decor-lottie abacus-bg" aria-hidden="true" data-nosnippet>
                    <dotlottie-player src="images/animations/abacus.lottie" autoplay loop></dotlottie-player>
                </div>

                <div class="section-header text-center" style="margin-bottom: 3rem;">
                    <h2>Frequently Asked 
                        <span class="crayon-wrap">
                            Questions
                            <svg class="crayon-svg highlight" viewBox="0 0 140 40" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 20,20 C 50,17 90,23 120,20" fill="none" stroke="#F6CD99" stroke-width="22" stroke-linecap="round"></path>
                            </svg>
                        </span>
                    </h2>
                </div>
                
                <div class="faq-list">
                    <ul>
                        <li>
                            <h3>What do I need to pack in my child's bag?</h3>
                            Just a spare change of clothes, appropriate outdoor wear (like wellies or a sunhat), and any special comforters. We provide all premium nappies, wipes, formula, and meals!
                        </li>
                        <li>
                            <h3>Can I drop off or pick up at any time?</h3>
                            Yes, our doors are open between 8:00am and 6:00pm. We just ask that you try to avoid drop-offs right in the middle of meal times so the children aren't disturbed while eating.
                        </li>
                        <li>
                            <h3>Do you accept childcare vouchers?</h3>
                            Absolutely. We are registered with all major workplace childcare voucher providers as well as the government Tax-Free Childcare scheme.
                        </li>
                        <li>
                            <h3>What is the staff-to-child ratio?</h3>
                            We strictly adhere to Ofsted guidelines to ensure maximum care and attention: 1:3 for babies under two, 1:4 for toddlers aged two, and 1:8 for pre-schoolers aged three and over.
                        </li>
                    </ul>
                </div>
            </div>
        </section>

        <!-- FOOTER -->
        <footer class="site-footer">
            <div class="container">
                <div class="footer-grid">
                    <div class="footer-col brand-col">
                        <h3 class="footer-logo-text"><span translate="no">Little Explorers Nursery</span></h3>
                        <p>A nurturing, home-from-home early years setting in the heart of Anytown, Anycity.</p>
                        <div class="footer-badges">
                            <a href="https://ratings.food.gov.uk/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="images/svgs/fhrs-badge-5.svg" alt="Food Hygiene Rating 5" class="footer-badge-img" width="160" height="80">
                            </a>
                            <a href="https://reports.ofsted.gov.uk/" target="_blank" rel="noopener noreferrer" aria-label="Read our Ofsted Report">
                                <img loading="lazy" src="images/svgs/Ofsted_Good_GP_White.svg" alt="Ofsted Good Provider" class="ofsted-footer-badge" width="60" height="60">
                            </a>
                        </div>
                    </div>
                    <div class="footer-col links-col">
                        <h4>Explore</h4>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="rooms">Our Rooms</a></li>
                            <li><a href="staff">Our Team</a></li>
                            <li><a href="fees">Fees & Funding</a></li>
                            <li><a href="contact">Contact</a></li>
                        </ul>
                    </div>
                    <div class="footer-col contact-col">
                        <h4>Get in Touch</h4>
                        <address>
                            <ul>
                                <li><strong>A:</strong> <a href="https://maps.google.com/?q=13+Anytown+Green,+Anycity+AT1+5LB" target="_blank" rel="noopener noreferrer">13 Anytown Green, Anycity AT1 5LB</a></li>
                                <li><strong>T:</strong> <a href="tel:+442079460123">020 7946 0123</a></li> 
                                <li><strong>E:</strong> <a href="mailto:hello@littleexplorersnursery.example.com">hello@littleexplorersnursery.example.com</a></li>
                            </ul>
                        </address>
                        <h4 class="hours-title">Opening Hours</h4>
                        <p class="hours-text"><span>Mon - Fri: 8:00am - 6:00pm</span><span>Sat - Sun: Closed</span></p>
                    </div>
                </div>
                <div class="footer-bottom">
                    <p>&copy; <span id="current-year"></span> All Rights Reserved - <a href="https://selcreative.co.uk/" target="_blank" rel="noopener noreferrer">SEL Creative</a></p>
                    <div class="legal-links">
                        <a href="privacy">Privacy Policy</a>
                        <span class="divider">|</span>
                        <a href="safeguarding">Safeguarding Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    </main>

</body>
</html>
